import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import cx from 'classnames';
import toTitleCase from '@clearscore-group/lib.normalize.title-case';
import useMedia from '@clearscore-group/lib.hooks.use-media';
import { mediaQuery } from '@clearscore/ui.rainbow.drivescore.tokens';
import ClickableItem from '@clearscore/ui.rainbow.drivescore.clickable-item';
var Size = {
  MICRO: 'MICRO',
  TINY: 'TINY',
  MINI: 'MINI',
  SMALL: 'SMALL',
  ADEQUATE: 'ADEQUATE',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  BIG: 'BIG',
  HUGE: 'HUGE',
  MASSIVE: 'MASSIVE',
  JUMBO: 'JUMBO'
};
var Weight = {
  EXTRATHIN: 'EXTRATHIN',
  THIN: 'THIN',
  LIGHT: 'LIGHT',
  REGULAR: 'REGULAR',
  MEDIUM: 'MEDIUM',
  SEMIBOLD: 'SEMIBOLD',
  BOLD: 'BOLD',
  EXTRABOLD: 'EXTRABOLD',
  BLACK: 'BLACK'
};
var Spacing = {
  TIGHT: 'TIGHT',
  WIDE: 'WIDE',
  EXPLODED: 'EXPLODED'
};
var Tag = {
  DIV: 'div',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span',
  LABEL: 'label',
  LEGEND: 'legend'
};
var Theme = {
  POSITIVE: 'POSITIVE',
  WARNING: 'WARNING',
  LIGHT: 'LIGHT',
  CAUTION: 'CAUTION'
};
var Preset = {
  H1: {
    size: Size.JUMBO,
    tag: Tag.H1,
    weight: Weight.REGULAR
  },
  H2: {
    size: [Size.LARGE, Size.MASSIVE, Size.BIG, Size.LARGE],
    tag: Tag.H2,
    weight: Weight.REGULAR,
    breakpoints: [null, mediaQuery['ds-mq-large'], mediaQuery['ds-mq-medium'], mediaQuery['ds-mq-small']]
  },
  H3: {
    size: Size.BIG,
    tag: Tag.H3,
    weight: Weight.REGULAR
  },
  H4: {
    size: Size.LARGE,
    tag: Tag.H4,
    weight: Weight.SEMIBOLD
  },
  H5: {
    size: Size.MEDIUM,
    tag: Tag.H5,
    weight: Weight.SEMIBOLD
  },
  H6: {
    size: Size.ADEQUATE,
    tag: Tag.H6,
    weight: Weight.SEMIBOLD
  },
  SUBTITLE1: {
    size: Size.SMALL,
    tag: Tag.P,
    weight: Weight.REGULAR
  },
  SUBTITLE2: {
    size: Size.MINI,
    tag: Tag.P,
    weight: Weight.REGULAR
  },
  DONUT1: {
    size: Size.HUGE,
    tag: Tag.P,
    weight: Weight.BOLD,
    isItalic: true
  },
  DONUT2: {
    size: Size.MEDIUM,
    tag: Tag.P,
    weight: Weight.BOLD,
    isItalic: true
  },
  BODY1: {
    size: Size.SMALL,
    tag: Tag.P,
    weight: Weight.LIGHT
  },
  BODY2: {
    size: Size.MINI,
    tag: Tag.P,
    weight: Weight.LIGHT
  },
  CAPTION: {
    size: Size.TINY,
    tag: Tag.P,
    weight: Weight.LIGHT
  },
  BUTTON: {
    size: Size.MINI,
    tag: Tag.P,
    weight: Weight.SEMIBOLD,
    spacing: Spacing.WIDE
  },
  OVERLINE: {
    size: Size.MICRO,
    tag: Tag.P,
    weight: Weight.SEMIBOLD,
    spacing: Spacing.EXPLODED
  },
  LABEL: {
    size: Size.TINY,
    tag: Tag.P,
    weight: Weight.REGULAR,
    spacing: Spacing.WIDE
  }
};
var styles$1 = {
  "component": "component--zuL0V",
  "isThemePositive": "isThemePositive---l6t2",
  "isThemeWarning": "isThemeWarning--NoDwJ",
  "isThemeLight": "isThemeLight--n-2Ls",
  "isSimpleLink": "isSimpleLink--xBTPe"
};
var _excluded$1 = ["children", "href", "isSimpleLink", "theme"];
var TextLink = function TextLink(_ref) {
  var _cx;
  var children = _ref.children,
    href = _ref.href,
    _ref$isSimpleLink = _ref.isSimpleLink,
    isSimpleLink = _ref$isSimpleLink === void 0 ? false : _ref$isSimpleLink,
    theme = _ref.theme,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var themeClass = styles$1["isTheme".concat(toTitleCase(theme))];
  return /*#__PURE__*/React.createElement(ClickableItem, _objectSpread({
    href: href
  }, props), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$1.component, (_cx = {}, _defineProperty(_cx, themeClass, theme), _defineProperty(_cx, styles$1.isSimpleLink, isSimpleLink), _cx))
  }, children));
};
var styles = {
  "text": "text--lCIjM",
  "isThemePositive": "isThemePositive--8fKPJ",
  "isThemeWarning": "isThemeWarning--uiadw",
  "isThemeLight": "isThemeLight--8Uf3p",
  "isThemeCaution": "isThemeCaution--QFMlq",
  "isSizeMicro": "isSizeMicro--RLlv-",
  "isSizeTiny": "isSizeTiny--2qVaN",
  "isSizeMini": "isSizeMini--F5ZKn",
  "isSizeSmall": "isSizeSmall--3Gcmb",
  "isSizeMedium": "isSizeMedium--C-Mn4",
  "isSizeAdequate": "isSizeAdequate--FEBt9",
  "isSizeLarge": "isSizeLarge--II4bB",
  "isSizeBig": "isSizeBig--Xb-S0",
  "isSizeHuge": "isSizeHuge--wr4Zx",
  "isSizeMassive": "isSizeMassive--UqAaj",
  "isSizeJumbo": "isSizeJumbo--aWs8V",
  "isLineHeightSmall": "isLineHeightSmall--900-r",
  "isLineHeightAdeguate": "isLineHeightAdeguate--4Ra0M",
  "isLineHeightMedium": "isLineHeightMedium--3RVmM",
  "isLineHeightGenerous": "isLineHeightGenerous--aZGAR",
  "isLineHeightLarge": "isLineHeightLarge--mvEfE",
  "isLineHeightGreat": "isLineHeightGreat--ttkCG",
  "isLineHeightBig": "isLineHeightBig--sSp93",
  "isLineHeightHuge": "isLineHeightHuge--ws-Lu",
  "isLineHeightMassive": "isLineHeightMassive--0-veb",
  "isLineHeightJumbo": "isLineHeightJumbo--VuuQI",
  "isLineHeightGigantic": "isLineHeightGigantic--xo4xz",
  "isWeightExtrathin": "isWeightExtrathin--u3sFU",
  "isWeightThin": "isWeightThin--AKG9X",
  "isWeightLight": "isWeightLight--0jrf8",
  "isWeightRegular": "isWeightRegular--OLDy6",
  "isWeightMedium": "isWeightMedium--scqTq",
  "isWeightSemibold": "isWeightSemibold--VMe5W",
  "isWeightBold": "isWeightBold--k5Bxs",
  "isWeightExtrabold": "isWeightExtrabold--OB9dk",
  "isWeightBlack": "isWeightBlack---fnBE",
  "isSpacingWide": "isSpacingWide--fCFfD",
  "isSpacingExploded": "isSpacingExploded--uaaT4",
  "isItalic": "isItalic---hgy-"
};
var _excluded = ["size", "theme", "dataId", "spacing", "breakpoints", "children", "isItalic", "tag", "weight"],
  _excluded2 = ["tag"],
  _excluded3 = ["tag"],
  _excluded4 = ["tag"],
  _excluded5 = ["tag"],
  _excluded6 = ["tag"],
  _excluded7 = ["tag"],
  _excluded8 = ["tag"],
  _excluded9 = ["tag"],
  _excluded10 = ["tag"],
  _excluded11 = ["tag"],
  _excluded12 = ["tag"],
  _excluded13 = ["tag"],
  _excluded14 = ["tag"],
  _excluded15 = ["tag"],
  _excluded16 = ["tag"],
  _excluded17 = ["tag"];
var Text = function Text(_ref) {
  var _cx2;
  var size = _ref.size,
    theme = _ref.theme,
    dataId = _ref.dataId,
    spacing = _ref.spacing,
    _ref$breakpoints = _ref.breakpoints,
    breakpoints = _ref$breakpoints === void 0 ? [] : _ref$breakpoints,
    children = _ref.children,
    _ref$isItalic = _ref.isItalic,
    isItalic = _ref$isItalic === void 0 ? false : _ref$isItalic,
    _ref$tag = _ref.tag,
    TagProp = _ref$tag === void 0 ? Tag.DIV : _ref$tag,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? Weight.REGULAR : _ref$weight,
    rest = _objectWithoutProperties(_ref, _excluded);
  var sizeValue = useMedia(breakpoints, size);
  var sizeClass = styles["isSize".concat(toTitleCase(sizeValue))];
  var weightClass = styles["isWeight".concat(toTitleCase(weight))];
  var spacingClass = styles["isSpacing".concat(toTitleCase(spacing))];
  var themeClass = styles["isTheme".concat(toTitleCase(theme))];
  return /*#__PURE__*/React.createElement(TagProp, _objectSpread({
    className: cx(styles.text, sizeClass, weightClass, (_cx2 = {}, _defineProperty(_cx2, styles.isItalic, isItalic), _defineProperty(_cx2, spacingClass, spacing), _defineProperty(_cx2, themeClass, theme), _cx2)),
    "data-qa": "text",
    "data-id": dataId
  }, rest), children);
};
Text.Tag = Tag;
Text.Size = Size;
Text.Theme = Theme;
Text.Preset = Preset;
Text.Weight = Weight;
Text.Link = TextLink;
Text.Spacing = Spacing;
var H1 = function H1(_ref2) {
  var tag = _ref2.tag,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.H1), {}, {
    tag: tag || Preset.H1.tag
  }));
};
var H2 = function H2(_ref3) {
  var tag = _ref3.tag,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.H2), {}, {
    tag: tag || Preset.H2.tag
  }));
};
var H3 = function H3(_ref4) {
  var tag = _ref4.tag,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.H3), {}, {
    tag: tag || Preset.H3.tag
  }));
};
var H4 = function H4(_ref5) {
  var tag = _ref5.tag,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.H4), {}, {
    tag: tag || Preset.H4.tag
  }));
};
var H5 = function H5(_ref6) {
  var tag = _ref6.tag,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.H5), {}, {
    tag: tag || Preset.H5.tag
  }));
};
var H6 = function H6(_ref7) {
  var tag = _ref7.tag,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.H6), {}, {
    tag: tag || Preset.H6.tag
  }));
};
var Donut1 = function Donut1(_ref8) {
  var tag = _ref8.tag,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.DONUT1), {}, {
    tag: tag || Preset.DONUT1.tag
  }));
};
var Donut2 = function Donut2(_ref9) {
  var tag = _ref9.tag,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.DONUT2), {}, {
    tag: tag || Preset.DONUT2.tag
  }));
};
var Subtitle1 = function Subtitle1(_ref10) {
  var tag = _ref10.tag,
    props = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.SUBTITLE1), {}, {
    tag: tag || Preset.SUBTITLE1.tag
  }));
};
var Subtitle2 = function Subtitle2(_ref11) {
  var tag = _ref11.tag,
    props = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.SUBTITLE2), {}, {
    tag: tag || Preset.SUBTITLE2.tag
  }));
};
var Body1 = function Body1(_ref12) {
  var tag = _ref12.tag,
    props = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.BODY1), {}, {
    tag: tag || Preset.BODY1.tag
  }));
};
var Body2 = function Body2(_ref13) {
  var tag = _ref13.tag,
    props = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.BODY2), {}, {
    tag: tag || Preset.BODY2.tag
  }));
};
var Button = function Button(_ref14) {
  var tag = _ref14.tag,
    props = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.BUTTON), {}, {
    tag: tag || Preset.BUTTON.tag
  }));
};
var Caption = function Caption(_ref15) {
  var tag = _ref15.tag,
    props = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.CAPTION), {}, {
    tag: tag || Preset.CAPTION.tag
  }));
};
var Overline = function Overline(_ref16) {
  var tag = _ref16.tag,
    props = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.OVERLINE), {}, {
    tag: tag || Preset.OVERLINE.tag
  }));
};
var Label = function Label(_ref17) {
  var tag = _ref17.tag,
    props = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), Preset.LABEL), {}, {
    tag: tag || Preset.LABEL.tag
  }));
};
Text.H1 = H1;
Text.H2 = H2;
Text.H3 = H3;
Text.H4 = H4;
Text.H5 = H5;
Text.H6 = H6;
Text.Label = Label;
Text.Body1 = Body1;
Text.Body2 = Body2;
Text.Donut1 = Donut1;
Text.Donut2 = Donut2;
Text.Button = Button;
Text.Caption = Caption;
Text.Overline = Overline;
Text.Subtitle1 = Subtitle1;
Text.Subtitle2 = Subtitle2;
export default Text;